export function setSlider(state, slider) {
  state.slider = slider;
}


